export default class CommentLikeController {
  static values = {
    url: String,
    liked: Boolean
  }

  static targets = ['button', 'count']

  connect() {
    this.liked = this.likedValue
  }

  async toggle() {
    const method = this.liked ? 'DELETE' : 'POST'

    try {
      const response = await fetch(this.urlValue, {
        method: method,
        headers: {
          'Accept': 'application/json',
          'X-CSRF-Token': this.csrfToken()
        }
      })

      if (response.ok) {
        const data = await response.json()
        this.liked = data.liked
        this.countTarget.textContent = data.likes_count

        if (data.liked) {
          this.buttonTarget.classList.add('comment__action--active')
        } else {
          this.buttonTarget.classList.remove('comment__action--active')
        }
      }
    } catch (error) {
      console.error('Comment like error:', error)
    }
  }

  csrfToken() {
    const meta = document.querySelector('meta[name="csrf-token"]')
    return meta ? meta.content : ''
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-controller="comment-like"]').forEach(el => {
    const controller = new CommentLikeController()

    controller.element = el
    controller.urlValue = el.dataset.commentLikeUrlValue
    controller.likedValue = el.dataset.commentLikeLikedValue === 'true'
    controller.buttonTarget = el.querySelector('[data-comment-like-target="button"]')
    controller.countTarget = el.querySelector('[data-comment-like-target="count"]')

    controller.connect()

    el.querySelectorAll('[data-action*="comment-like#toggle"]').forEach(btn => {
      btn.addEventListener('click', () => controller.toggle())
    })
  })
})
